import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <h4>Developed by Dasol Lim</h4>
            <p>Keep going. Don’t let today’s "almost" make you forget tomorrow’s potential</p>
        </footer>
    );
}

export default Footer;